export const cardStyle = {
  textAlign: 'center',
  background: '#fff3cd',
  height: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 5,
  borderRadius: '5px',
  marginBottom: 10,
};
export const barcodeCard = {
  background: '#fff',
  width: '100%',
  height: '120px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  padding: '20px',
  borderRadius: '10px',
};
